// Logos live in src/components/Classification/images/realcos/ so the
// transition page and the in-game header share the same set. `name`
// matches the displayName used in realcoData.js — the level type for
// a realco assignment is `real-public-co-<name>` and the transition
// highlights the matching tile.
import appleLogo from '../../../../Classification/images/realcos/apple.png';
import costcoLogo from '../../../../Classification/images/realcos/costco.png';
import fedexLogo from '../../../../Classification/images/realcos/fedex.png';
import googleLogo from '../../../../Classification/images/realcos/google.png';
import chaseLogo from '../../../../Classification/images/realcos/chase.png';
import marriottLogo from '../../../../Classification/images/realcos/marriott.png';
import mcdonaldsLogo from '../../../../Classification/images/realcos/mcdonalds.png';
import netflixLogo from '../../../../Classification/images/realcos/netflix.png';
import nikeLogo from '../../../../Classification/images/realcos/nike.png';
import starbucksLogo from '../../../../Classification/images/realcos/starbucks.png';
import disneyLogo from '../../../../Classification/images/realcos/disney.png';
import warnerMusicLogo from '../../../../Classification/images/realcos/warner-music.png';

export const accounts = [
  'Sales Revenue',
  'Accounts Receivables',
  'Salaries & Wages Payable',
  'Supplies',
  'Rent Expense',
  'Accounts Payable',
  'Income Tax Payable',
  'Selling Expense',
  'Interest Expense',
  'Land',
  'Cash',
  'Advertising Expense',
  'Property and Equipment',
  'Loan Payable',
  'Depreciation Expense'
];

export const realCompanies = [
  { name: 'Apple',         src: appleLogo,        width: 50 },
  { name: 'Costco',        src: costcoLogo,       width: 100 },
  { name: 'FedEx',         src: fedexLogo,        width: 100 },
  { name: 'Google',        src: googleLogo,       width: 100 },
  { name: 'Chase',         src: chaseLogo,        width: 100 },
  { name: 'Marriott',      src: marriottLogo,     width: 100 },
  { name: "McDonald's",    src: mcdonaldsLogo,    width: 80 },
  { name: 'NetFlix',       src: netflixLogo,      width: 100 },
  { name: 'Nike',          src: nikeLogo,         width: 80 },
  { name: 'Starbucks',     src: starbucksLogo,    width: 80 },
  { name: 'Disney',        src: disneyLogo,       width: 80 },
  { name: 'Warner Music',  src: warnerMusicLogo,  width: 80 },
];